module.exports = __webpack_public_path__ + "img/评论3_03.bc89e489.jpg";